import {
  DEFAULT_LOCALE,
  matchLocale,
  SupportedLocale,
  supportsLocale,
} from '../../../translations/locales';

type PartialWindowNavigator = { navigator?: { language?: string; languages?: readonly string[] } };

const getUserLocale = (window: PartialWindowNavigator | null): SupportedLocale => {
  try {
    if (!window || !window.navigator) {
      return DEFAULT_LOCALE;
    }

    const { language, languages } = window.navigator;
    const safeLanguages = languages || [];

    const candidates = language ? [language, ...safeLanguages] : safeLanguages;

    for (let i = 0; i < candidates.length; i += 1) {
      const candidate = candidates[i];

      if (supportsLocale(candidate)) {
        return matchLocale(candidate);
      }
    }

    return DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
};

export default getUserLocale;
